import type { DownloadFailedEvent } from '@capgo/capacitor-updater';
import { recordCapgoConsoleLine } from './capgoConsoleRing';
import { CAPGO_PREFIX_ANDROID, classifyCapgoReason } from './capgoReason';

type DownloadFailedWithError = DownloadFailedEvent & { error?: unknown };

export type DownloadFailedSubscriber = (
  eventName: 'downloadFailed',
  listener: (state: DownloadFailedEvent) => void,
) => Promise<unknown>;

// The Android disk precheck reaches us only via this event's `error`; unclassified aggregates would shadow the per-file reason line.
export const listenForCapgoDownloadFailed = async (subscribe: DownloadFailedSubscriber): Promise<void> => {
  try {
    await subscribe('downloadFailed', (state) => {
      const error = (state as DownloadFailedWithError | undefined)?.error;
      if (typeof error !== 'string' || error === '') return;
      const line = `${CAPGO_PREFIX_ANDROID}Download error: ${error}`;
      const { reasonClass } = classifyCapgoReason(line);
      if (reasonClass === 'unclassified' || reasonClass === 'android_no_reason') return;
      recordCapgoConsoleLine(line);
    });
  } catch {
    // diagnostics must never break boot
  }
};
